export default __webpack_public_path__ + "68697e59296e92e4c969169ee7fcaaa2.png";